import lang from "@/views/modules/Administration/language/en";
import breadcrumbs from "@/views/modules/Administration/MenuList.vue";
import loader from "@/views/shared/loading/Loading.vue";

export default {
    name: "saml-setting",

    components: {
        breadcrumbs,
        loader,
    },
    data() {
        return {
            lang: [],
            loading: true,
            saml: {

            }
        }
    },
    mounted() {
        this.lang = lang;
        this.dom_array = this.domArrayVariable;
        this.getSamlSetting();
    },
    methods: {
        generateMetadataHref() {
            return this.saml.uuid ? `../../saml/${this.saml.uuid}/metadata` : '';
        },
        getSamlSetting() {
            const self = this;
            window.currentAction = 'list';
                axios.get('api/modules/administration/saml-values').then(function (response) {
                if (response.data != '' && response.data != 'null') {
                    self.saml = response.data;
                }
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
        saveSamlSetting() {
            const errorMessages = document.getElementsByClassName('error-message');

            while (errorMessages.length > 0) {
                errorMessages[0].remove();
            }
            const self = this;
            self.loading = true;
            axios.post('api/modules/administration/samlsettings', self.saml).then(function (response) {
                self.loading = false;
            }).catch(function () {
                self.loading = false;
                let err = localStorage.getItem('Errors');
                let err_msg = (JSON.parse(err));
                let err_msg2 = err_msg.errors;
                Object.keys(err_msg2).forEach((key) => {
                    let errorval = err_msg2[key];
                    const input = document.getElementById(key);
                    const errorDiv = document.createElement('span');
                    errorDiv.className = 'error-message error';
                    errorDiv.textContent = errorval;
                    input.insertAdjacentHTML('afterend', errorDiv.outerHTML);
                });
                localStorage.removeItem('Errors');
            });
        },
    },

}
